import router from './router'
import store from './store'
import { Message } from 'element-ui'
import requestMain from '@/utils/requestMain'
import requestBusiness from '@/utils/requestBusiness'

const loginRoutePath = '/login'
const whiteList = [loginRoutePath, '/clause', '/pdf'] // no redirect whiteList

router.onError(error => {
  const pattern = /Loading chunk (\w)+ failed/g
  const isError = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if(isError) {
    router.replace(targetPath)
  }
})

router.beforeEach((to, from, next) => {
  /* has token */

  const checkPermission = async () => {
    const hasToken = localStorage.getItem('token')

    if (hasToken) {
      if (to.path === loginRoutePath) {
        next({ path: "/" })
      } else {
        // determine whether the user has obtained his permission roles through getUserInfo
        const hasRoles = store.getters.roles
        if (hasRoles) {
          next()
        } else {
          try {
            // get user info
            const companyId = localStorage.getItem('companyId') || 0
            const { user, roles } = await store.dispatch('user/getUserInfo', companyId)

            const userModel = { userId: user.id, companyId: companyId }
            await store.dispatch('user/selectedCompany', userModel)

            const routes = await store.dispatch('permission/generateRoutes', roles)
            routes.forEach(route => {
              router.addRoute(route)
            })
            next({ ...to, replace: true })
          } catch (error) {
            // remove token and go to login page to re-login
            Message.error({ type: 'error', message: error || 'Has Error' })
            next(`/login?redirect=${to.path}`)
          }
        }
      }
    } else {
      if (whiteList.includes(to.path)) {
        // 在免登录名单，直接进入
        next()
      } else {
        next(`/login?redirect=${to.path}`)
      }
    }
  }
  if (!store.getters.config.brandCode) {
    store.dispatch('setConfig').then(res => {
      requestMain.defaults.baseURL = store.getters.config.appUrl + '/cloud'
      requestBusiness.defaults.baseURL = store.getters.config.appUrl + '/cloud'
      checkPermission()
    })
  } else {
    checkPermission()
  }
})
